import React from 'react';
import RemotePath from '../../../consts/RemotePaths';

/**
 * IntroScreen
 * Tela hero exibida antes do step 0.
 * Exibe cover photo da clínica (ou placeholder) acima do título.
 */
export default function IntroScreen({ onStart, company }) {
    const coverImage = (company?.banner && company?.id)
        ? RemotePath.PATH_USER_UPLOADS_COMPANY_BANNER(company.id) + company.banner
        : '';

    return (
        <div className="ps-intro">
            {/* Cover photo da clínica */}
            <div className="ps-intro__cover">
                {coverImage ? (
                    <img
                        src={coverImage}
                        alt={company?.name || 'Clínica'}
                        className="ps-intro__cover-img"
                    />
                ) : (
                    <div className="ps-intro__cover-placeholder">
                        {/* Ícone de construção / clínica */}
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#CBD5E0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                            <polyline points="9 22 9 12 15 12 15 22" />
                        </svg>
                        {company?.name && (
                            <span className="ps-intro__cover-placeholder-name">{company.name}</span>
                        )}
                    </div>
                )}
            </div>

            {/* Hero copy */}
            <div className="ps-intro__hero">
                <h1 className="ps-intro__title">
                    Agende sua consulta com{' '}
                    <span className="ps-intro__title-highlight">facilidade</span>
                </h1>
                <p className="ps-intro__subtitle">
                    Veja os horários disponíveis e solicite seu agendamento pelo WhatsApp.
                </p>
            </div>

            {/* Trust items */}
            <div className="ps-intro__trust">
                <div className="ps-intro__trust-item">
                    <div className="ps-intro__trust-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ED3680" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                            <line x1="16" y1="2" x2="16" y2="6" />
                            <line x1="8" y1="2" x2="8" y2="6" />
                            <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                    </div>
                    <span className="ps-intro__trust-text">Horários atualizados em tempo real</span>
                </div>

                <div className="ps-intro__trust-item">
                    <div className="ps-intro__trust-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ED3680" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                            <circle cx="12" cy="7" r="4" />
                        </svg>
                    </div>
                    <span className="ps-intro__trust-text">Profissionais especializados</span>
                </div>

                <div className="ps-intro__trust-item">
                    <div className="ps-intro__trust-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ED3680" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                        </svg>
                    </div>
                    <span className="ps-intro__trust-text">Atendimento ágil pelo WhatsApp</span>
                </div>
            </div>

            {/* CTA */}
            <button className="ps-btn ps-btn--primary ps-btn--full" onClick={onStart}>
                Ver horários disponíveis
            </button>

            {/* Dados protegidos */}
            <p className="ps-trust-note">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
                Seus dados estão protegidos
            </p>
        </div>
    );
}
